import { render, staticRenderFns } from "./SelectPackages.vue?vue&type=template&id=6aaadf9e"
import script from "./SelectPackages.vue?vue&type=script&lang=js"
export * from "./SelectPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports